import { Component, Input, SimpleChanges } from '@angular/core';
import { BaseComponent } from 'src/app/system-common/base/base.component';
import { AgentService } from '../services/agent.service';
import { FieldItem } from 'src/app/models/common/field-item';

@Component({
  selector: '',
  template: '',
})
export class AgentPartyIdentityHandlerComponent extends BaseComponent<AgentService> {
  @Input() partyModel: any;

  constructor(agentService: AgentService) {
    super(agentService);
  }

  public onAddPartyIdentity(event) {
    this.service.addPartyIdentity(this.partyModel);
  }

  ngOnChanges(changes: SimpleChanges) {
    super.ngOnChanges(changes);
  }

  protected identityNum_change(item: FieldItem) {
    for (let i = 0; i < this.service.responseIO.data.AgentParty.IdentityList.length; i++) {
      if (this.service.responseIO.data.AgentParty.IdentityList[i].guid == item.model.guid)
        this.service.responseIO.data.AgentParty.IdentityList[i].identityNum = item.fieldValue.toUpperCase();
    }
  }
}
